<template>
    <div>
        <Loading :value="loading" ></Loading>
        <!--haut-->
        <v-layout row>
            <!--stats nb contrat-->
            <v-flex xs3>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-layout row>
                            <v-flex xs12 class="mb-2 mr-1">
                                <v-card color="cyan darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs5>
                                                <div>
                                                    <div class="headline">
                                                        <v-icon dark>assignment</v-icon>
                                                        {{nbContrats}}
                                                    </div>
                                                    <div>Total contrat(s)</div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs7>
                                                <div>Contrat à renouveler</div>

                                                <div class="display-3">

                                                    {{nbContratArenouv}}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs12>
                        <v-layout row>
                            <v-flex xs12 class="mb-2 mr-1">
                                <v-card color="orange darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs7>
                                                <div>
                                                    <div class="headline">
                                                        <v-icon dark >people</v-icon>
                                                        {{nbEmploye}}
                                                    </div>
                                                    <div>Total employes(s)</div>
                                                </div>

                                                <div class="mt-4">
                                                    <div class="headline">
                                                        <v-icon dark >view_list</v-icon>
                                                        {{nbDmdAbsAttente}}
                                                    </div>
                                                    <div >
                                                        Demande(s) d'absence en attente de validation
                                                        </div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs5>
                                                <div>Nbre d'absent(s)</div>
                                                <div class="display-3">{{nbAbsent}}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs12>
                        <v-layout row>
                            <v-flex xs12 class="mb-2 mr-1">
                                <v-card color="red darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs5>
                                                <div>
                                                    <div class="headline">
                                                        <v-icon dark>assignment</v-icon>
                                                        {{nbContrats}}
                                                    </div>
                                                    <div>Total contrat(s)</div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs7>
                                                <div>Contrat à renouveler</div>

                                                <div class="display-3">

                                                    {{nbContratArenouv}}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>

            <!--stat card  contrat-->
            <v-flex xs3>
                <v-layout row mb-4 ml-2 mr-2>
                    <v-flex xs12 >
                        <v-card class="elevation-4" >
                           <!--Grap-->

                            <v-card-title primary-title class="blue-grey lighten-5"  >

                                    <div id="chartTypeContrat" style="width: 100%; height:255px"></div>

                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="grey lighten-4">
                                <v-layout row class="mb-2">
                                    <v-flex xs6>
                                        <div class="orange--text text-xs-left">
                                            <div   >
                                                STAGE PROFESSIONNEL
                                            </div>
                                            <div class="headline">{{nbContProfession}}</div>
                                        </div>
                                    </v-flex>

                                    <v-flex xs6 >
                                        <div class="red--text text-xs-right"  >
                                            <div>
                                                STAGE FORMATION
                                            </div>
                                            <div class="headline">{{nbContFormation}}</div>
                                        </div>
                                    </v-flex>

                                </v-layout>

                                <v-layout row class="mb-2">
                                    <v-flex xs6>
                                        <div class="purple--text text-xs-left">
                                            <div >
                                                TEMPS PARTIEL
                                            </div>
                                            <div class="headline ">{{nbContPartiel}}</div>
                                        </div>
                                    </v-flex>

                                    <v-flex xs6 >
                                        <div class="cyan--text text-xs-right"  >
                                            <div >
                                                CONSULTANT
                                            </div>
                                            <div class="headline">{{nbContConsult}}</div>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row >
                                    <v-flex xs6>
                                        <div class="primary--text text-xs-left" >
                                            <div>
                                                CDD
                                            </div>
                                            <div class="headline ">{{nbContCDD}}</div>
                                        </div>
                                    </v-flex>

                                    <v-flex xs6 >
                                        <div class="green--text text-xs-right" >
                                            <div>
                                               CDI
                                            </div>
                                            <div class="headline">{{nbContCDI}}</div>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs6 >
                <v-layout ml-2 >
                    <v-flex sm12 >
                        <v-card class="elevation-4" style="height:505px;">
                            <v-toolbar class="text-xs-center"   color="blue-grey darken-2" dark>
                                <v-toolbar-title>
                                    <v-chip color="light-green accent-4" text-color="white">
                                        <span class="title">{{listeAbsence.length}}</span>
                                    </v-chip>
                                    employés absents ce mois</v-toolbar-title>
                            </v-toolbar>
                            <v-card-title class="text-xs-center">
                                <el-table
                                        :data="listeAbsence"
                                        style="width: 100%;" height="370">
                                    <el-table-column type="expand">
                                        <template slot-scope="scope">
                                            <p>Motif:</p>
                                            <p>
                                                <el-input v-model="scope.row.description" type="textarea" >

                                                </el-input>
                                            </p>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                            label="Avatar"
                                            prop="avatar">
                                        <template  slot-scope="scope">
                                            <div class="demo-basic--circle">
                                                <div class="block">
                                                    <v-avatar
                                                            :tile="false"
                                                            :size="50"
                                                            color="grey lighten-4"
                                                    >
                                                        <img :src="scope.row.urlAvatar" alt="avatar">
                                                    </v-avatar>
                                                </div>

                                            </div>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                            label="Nom & Prénom(s)"
                                            prop="nom">
                                    </el-table-column>
                                    <el-table-column
                                            label="Période"
                                            prop="periode">
                                    </el-table-column>
                                </el-table>
                            </v-card-title>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>



        <!--bas-->
        <v-layout row mb-1>
            <v-flex mr-2 xs6>
                <v-layout mb-2 >
                    <v-flex sm12 >
                        <v-card class="elevation-4" style="height:450px;">
                            <v-toolbar class="text-xs-center"   color="brown darken-2" dark>
                                <v-toolbar-title>
                                    <v-chip color="light-green accent-4" text-color="white">
                                        <span class="title">{{listeContratsRenouv.length}}</span>
                                    </v-chip>
                                     contrats expiré(s) à renouveler</v-toolbar-title>
                            </v-toolbar>
                            <v-card-title class="text-xs-center">
                                <el-table
                                        :data="listeContratsRenouv"
                                        style="width: 100%">
                                    <el-table-column
                                            label="ID Contrat"
                                            prop="idContrat">
                                    </el-table-column>
                                    <el-table-column
                                            label="Type contrat"
                                            prop="typeContrat">
                                    </el-table-column>
                                    <el-table-column
                                            label="Employe"
                                            prop="employe">
                                    </el-table-column>
                                    <el-table-column
                                            label="Période"
                                            prop="periode">
                                    </el-table-column>
                                </el-table>
                            </v-card-title>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs6 >
                <v-layout mb-2 >
                    <v-flex sm12 >
                        <v-card class="elevation-4" style="height:450px;">
                            <v-toolbar class="text-xs-center"   color="deep-orange darken-2" dark>
                                <v-toolbar-title>
                                    <v-chip color="light-green accent-4" text-color="white">
                                        <span class="title">{{listeContratsRenouvMoisProch.length}}</span>
                                    </v-chip>

                                    contrats à renouveler le mois prochain</v-toolbar-title>
                            </v-toolbar>
                            <v-card-title class="text-xs-center">
                                <el-table
                                        :data="listeContratsRenouvMoisProch"
                                        style="width: 100%">
                                    <el-table-column
                                            label="ID Contrat"
                                            prop="idContrat">
                                    </el-table-column>
                                    <el-table-column
                                            label="Type contrat"
                                            prop="typeContrat">
                                    </el-table-column>
                                    <el-table-column
                                            label="Employe"
                                            prop="employe">
                                    </el-table-column>
                                    <el-table-column
                                            label="Période"
                                            prop="periode">
                                    </el-table-column>
                                </el-table>
                            </v-card-title>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>

        </v-layout>

        <!--Liste conge-->
        <v-layout row mb-3>
            <v-flex sm12>
                <v-card class="elevation-4" >
                    <v-toolbar class="text-xs-center"   color="cyan darken-2" dark>
                        <v-toolbar-title>Demande d'absences</v-toolbar-title>
                    </v-toolbar>
                    <v-card-title class="text-xs-center" style="height:auto;">
                        <data-tables
                                :data="listeDemandeAbs"
                                style="width: 100%;" height="500">
                            <el-table-column v-if="false"
                                    label="ID"
                                    width="200"
                                    prop="id">
                                <template slot-scope="scope">
                                    <el-tag  class="body-2">{{scope.row.id}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="Avatar"
                                    width="100"
                                    align="center"
                                    prop="avatar">
                                <template  slot-scope="scope">
                                    <div class="demo-basic--circle">
                                        <div class="block">
                                            <v-avatar
                                                    :tile="false"
                                                    :size="50"
                                                    color="grey lighten-4"
                                            >
                                                <img :src="scope.row.urlAvatar" alt="avatar">
                                            </v-avatar>
                                        </div>

                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    label="Nom & Prénom(s)"
                                    width="200"
                                    prop="nom">
                                <template slot-scope="scope">
                                    <el-tag  class="body-2">{{scope.row.nom}}</el-tag>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    align="center"
                                    label="Demande(s) d'absence">
                                <el-table-column
                                        align="center"
                                        prop="vacance"
                                        label="Congé restant/Total"
                                >
                                    <template slot-scope="props">
                                        <span class="blue--text title">{{props.row.vacance}}</span>

                                    </template>
                                </el-table-column>

                                <el-table-column
                                        align="center"
                                        prop="mariage"
                                        label="Mariage"
                                >
                                    <template slot-scope="props">
                                        <span class="green--text title">{{props.row.mariage}}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                        align="center"
                                        prop="deuil"
                                        label="Deuil"
                                >
                                    <template slot-scope="props">
                                        <span class="red--text title">{{props.row.deuil}}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                        align="center"
                                        prop="famille"
                                        label="familial et medical"
                                >
                                    <template slot-scope="props">
                                        <span class="purple--text title">{{props.row.famille}}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                        align="center"
                                        prop="autre"
                                        label="Autre"
                                >
                                    <template slot-scope="props">
                                        <span class="black--text title">{{props.row.autre}}</span>
                                    </template>
                                </el-table-column>

                            </el-table-column>
                        </data-tables>
                    </v-card-title>


                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        components: {Loading},
        name: "boardResource",
        data(){
            return {
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                loading: false,

                listeAbsence:[],
                listeDemandeAbs:[],
                listeContratsRenouv:[],
                listeContratsRenouvMoisProch:[],

                nbContrats: 0,
                nbContratArenouv: 0,
                nbContFormation:0,
                nbContProfession:0,
                nbContPartiel:0,
                nbContConsult: 0,
                nbContCDD:0,
                nbContCDI:0,

                nbEmploye: 0,
                nbAbsent: 0,
                nbDmdAbsAttente:0,


            }
        },
        methods:{
            loadStatistiqueRh(){
                //this.loading = true;
                let url = this.domaine+"rh/statistique";
                this.$http.get(url).then(resp => {
                    let dataStat = resp.body.dataStat;
                    //chargement des donnees de stst
                    this.nbContrats = dataStat.nbContrats;
                    this.nbContratArenouv = dataStat.nbContratsArenouveler;
                    this.nbContFormation = dataStat.nbContratsFormation;
                    this.nbContProfession = dataStat.nbContratsProf;
                    this.nbContPartiel = dataStat.nbContratsTempsPart;
                    this.nbContConsult =  dataStat.nbContratsConsultant;
                    this.nbContCDD = dataStat.nbContratsCDD;
                    this.nbContCDI = dataStat.nbContratsCDI;
                    this.nbEmploye = dataStat.nbEmployes;
                    this.nbAbsent = dataStat.nbAbsents;
                    this.nbDmdAbsAttente = dataStat.nbAbsencesAttente;

                    this.listeContratsRenouv = dataStat.listeContArenouveler;
                    this.listeContratsRenouvMoisProch = dataStat.listeContratArenouvMoisProch;
                    this.listeAbsence = dataStat.listeEmployeAbsent;
                    this.listeDemandeAbs = dataStat.listeDemandeEmpl;

                    this.statTypeContrat(dataStat.dataPie)
                    this.loading = false
                }, error =>{
                    this.loading = false
                    this.$message.error("Echec lors du chargement des informations de statistique")
                });
            },
            statTypeContrat(dataTypeContrat) {
                let option = {
                    title: {
                        text: "",
                        left: 'top',
                        textStyle: {
                            color: '#000',
                            fontWeight: 'normal',
                            position: 'top'
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 10,
                        data: []
                    },
                    series: [
                        {
                            name: 'Nb Contrat(s)',
                            type: 'pie',
                            width: 'auto',
                            color:["#F44336","#FF9800","#9C27B0","#00BCD4","#4CAF50","#03A9F4"],
                            radius: ['60%', '90%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: true,
                                position: 'right'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '10',
                                    fontWeight: 'normal'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [

                            ]
                        }
                    ]
                };

                for(let datapie in dataTypeContrat)
                {
                    option.series[0].data.push({value: dataTypeContrat[datapie], name:"" });
                }


                let chartContrat = echarts.init(document.getElementById('chartTypeContrat'))
                chartContrat.setOption(option)
            },
        },
        mounted(){
            this.loadStatistiqueRh()
        }
    }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/resourceHumaine/board_resource.vue